export const CLIENT_CREER = 'client/CLIENT_CREER';
export const CLIENT_MODIFIER = 'client/CLIENT_MODIFIER';
export const CLIENT_RECHERCHER = 'client/CLIENT_RECHERCHER';
export const LIRE_CLIENT = 'client/LIRE_CLIENT';
export const LISTER_CLIENT = 'client/LISTER_CLIENT';
export const RECHERCHE_RAPIDE_CLIENT = 'client/RECHERCHE_RAPIDE_CLIENT';

export const defaultFiltre = {};
